import classes from 'components/widgets/ProjectScorecards/components/PredictedMilestoneCell/PredictedMilestoneCell.module.scss';

interface Props {
    milestone: string;
    taskId: string;
}

export const PredictedMilestoneCell = ({ milestone, taskId }: Props) => {
    return (
        <>
            <span className={classes.milestone}>{milestone}</span> <span>({taskId})</span>
        </>
    );
};
